import {CampaignTags} from '../campaigns/campaign_tags'

export class DNICampaignsCreate extends HTMLElement {
  constructor(list_view, rows_data, is_admin) {
    super();
    this._is_admin = is_admin;
    this.list_view = list_view;
    this.rows_data = rows_data;
  }
  connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;
    this.data = {};
    this.all_numbers = this.rows_data.map(obj => obj.static_number).toArray();
    this.dni_campaign_info = new DNICampaignInfo(this._is_admin, this.domain_id, this.data, this.all_numbers);
    this.dni_enable_features = new DNIEnableFeatures(this._is_admin, this.data);
    this.dni_advanced_settings = new DNIAdvancedSettings(this.data);
    this.dni_number_settings = new DNINumberSettings(this.data);
    this.innerHTML = 
    `<style>
      dni-campaigns-create .fas {
        font-family: FontAwesome;
      }
    </style>
    <div class="row">
      
      <div class="col-lg-9 col-md-12 col-lg-offset-1" id="new-dni-main">
        <h3><span id="campaign-back"></span> Digital Campaign Wizard</h3>
        <p>Build your Digital Campaign</p>
      </div>
      
    </div>`;
    this.querySelector('#new-dni-main').appendChild(this.dni_campaign_info);
    this.querySelector('#new-dni-main').appendChild(this.dni_enable_features);
    this.querySelector('#new-dni-main').appendChild(this.dni_advanced_settings);
    this.querySelector('#new-dni-main').appendChild(this.dni_number_settings);

    this.querySelector('#campaign-back').addEventListener('click', function() {
      this.cancelNew();
    }.bind(this))

    this.querySelectorAll('.step-cancel').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        this.cancelNew();
      }.bind(this))
    })

    this.querySelector('#step-4-finish').addEventListener('click', function(e) {
      e.preventDefault()
      this.saveCampaign(e.target)
    }.bind(this))
  }

  cancelNew() {
    this.list_view.show();
    this.remove();
  }

  async saveCampaign(button) {
    button.disabled = true;
    if(this.dni_campaign_info.validateStep() && this.dni_enable_features.validateStep() && this.dni_advanced_settings.validateStep()
      && this.dni_number_settings.validateStep()) {
      this.dni_campaign_info.compileData();
      this.dni_enable_features.compileData();
      this.dni_advanced_settings.compileData();
      this.dni_number_settings.compileData();
      let res = await fetch(`/admin/domains/${this.domain_id}/dni_campaigns`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(this.data)
      })
      button.disabled = false;
      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('New Campaign created', 'success');
        this.list_view.show();
        this.list_view.addNewCampaign(response.data)
        TreatmentsManager.reloadTreatments();
        this.remove();
      } else {
        Common.notify(`Unable to save Campaign. ${response.error ? response.error : ""}`, 'error');
      }
    } else {
      // Validation error
      button.disabled = false;
    }
  }
}

customElements.define('dni-campaigns-create', DNICampaignsCreate)

class DNICampaignInfo extends HTMLElement {
  constructor(is_admin, domain_id, data, all_numbers) {
    super();
    this._is_admin = is_admin;
    this.domain_id = domain_id;
    this.data = data;
    this.all_numbers = all_numbers;
  }
  async connectedCallback() {
    this.innerHTML = 
    `<style>
      .dni-address {
        background-color: #F5F5F5;
      }
    </style>
    <div class="step-number-header">
      <div class="campaign-step-num campaign-step-active"><span>1</span></div>
      <h4>Campaign Info</h4>
    </div>
    
    <div class="step-container">
      
      <div class="camp-line">
        <div class="camp-vertical-arrow hidden">
          <div class="camp-arrow-down"></div>
        </div>
      </div>
      <div class="step-main">
        <div class="panel panel-default campaign-panel">
          <div class="errors" data-cy="errors-1"></div>
          <label>Name</label>
          <input type="text" class="form-control" id="dni-name" data-cy="dni-name" placeholder="" maxlength="40">
          
          <div class="tags-container"></div>
          <label>Phone Number to Replace</label>
          <input type="text" class="form-control ring_to_endpoint" id="dni-number" data-cy="dni-number" placeholder="(123) 444-5566">
          <label>Pool Size</label>
          <select class="form-control" id="campaign-count" data-cy="campaign-count">
          </select>
          <input id="dni-address-checkbox" type="checkbox" checked><span> Use Default Address</span>
          <div class="dni-address panel panel-default hidden">
            <label>Location Name</label>
            <input id="dni-location-name" class="form-control" type="text" placeholder="Location Name">
            <label>Address Line 1</label>
            <input id="dni-address-1" class="form-control" type="text" placeholder="Address Line 1">
            <label>Address Line 2</label>
            <input id="dni-address-2" class="form-control" type="text" placeholder="Address Line 2">
            <label>City</label>
            <input id="dni-city" class="form-control" type="text" placeholder="City">
            <div class="col-sm-6" style="padding-left: 0;">
              <label>State/Province/Region</label>
              <input id="dni-region" class="form-control" type="text" placeholder="State/Province/Region">
            </div>
            <div class="col-sm-6" style="padding-right: 0;">
              <label>Zip/Postal Code</label>
              <input id="dni-zip" class="form-control" type="text" placeholder="Zip/Postal Code">
            </div>
          </div>
        </div>
        <div class="campaign-buttons">                                                                        
          <button class="btn btn-primary pull-right campaign-row-button" id="dni-step-1-next" data-cy="dni-step-1-next">Next</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
        </div>
      </div>
    </div>`;

    this.querySelector(".tags-container").appendChild(new CampaignTags(this.domain_id));

    $(this.querySelector("#dni-number")).mask('(999) 999-9999')
    this.campaignNumber();

    let res = await fetch(`/admin/domains/${this.domain_id}/tags`);
    let tags = await res.json();

    this.querySelector('#dni-step-1-next').addEventListener('click', function(e) {
      e.preventDefault();
      if(this.validateStep()) {
        this.querySelector('.campaign-buttons').classList.add('hidden');
        this.querySelector('.camp-vertical-arrow').classList.remove('hidden');
        document.querySelector('dni-enable-features').revealStep();
      }
    }.bind(this))

    this.querySelector('#dni-address-checkbox').addEventListener('click', function() {
      this.querySelector('#dni-address-checkbox').checked == true ? this.querySelector('.dni-address').classList.add('hidden') : this.querySelector('.dni-address').classList.remove('hidden')
    }.bind(this))

    this.querySelector('#campaign-count').onchange = (e) => {document.querySelector('dni-number-settings').pool_size = e.target.value}
    document.querySelector('dni-number-settings').pool_size = this.querySelector('#campaign-count').value;
    
  }
  campaignNumber() {
    let options = [];
    for(let i = 5; i <= 50; i+=5) {
      options.push(`<option value="${i}">${i}</option>`);
    }
    this.querySelector('#campaign-count').innerHTML = options.join('');
  }

  validateStep() {
    let isValid = true;
    let errors = "";
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })
    if(!this.querySelector('#dni-name').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a digital campaign name.
                  </div>`;
      this.querySelector('#dni-name').classList.add('error')
      isValid = false;
    } 

    if(!this.querySelector('#dni-number').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a valid phone number.
                  </div>`;
      this.querySelector('#dni-number').classList.add('error')
      isValid = false;
    }

    if(this.all_numbers.some(num => num == this.querySelector('#dni-number').value.replace(/\D/g,''))) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Number cannot already be in use in another campaign.
                  </div>`;
      this.querySelector('#dni-number').classList.add('error')
      isValid = false;
    }

    if(!this.querySelector('campaign-tags').validate()) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please select a tag name.
                  </div>`;
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;

    return isValid
  }

  compileData() {
    this.data.campaign_name = this.querySelector('#dni-name').value;
    this.data.static_number = this.querySelector('#dni-number').value.replace(/\D/g,'');
    this.data.dni_pool_size = Number(this.querySelector('#campaign-count').value);

    // let tags = [];
    // this.querySelector('.select-tags').options.forEach(option => {
    //   tags.push(option.value)
    // })
    this.data.campaign_tag_data = this.querySelector("campaign-tags").getData();

    if(!this.querySelector('#dni-address-checkbox').checked) {
      this.data.location_name = this.querySelector("#dni-location-name").value;
      this.data.location_address_line_1 = this.querySelector("#dni-address-1").value;
      this.data.location_address_line_2 = this.querySelector("#dni-address-2").value;
      this.data.location_address_city = this.querySelector("#dni-city").value;
      this.data.location_address_state = this.querySelector("#dni-region").value;
      this.data.location_address_zip = this.querySelector("#dni-zip").value;
    }
  }
}

customElements.define('dni-campaign-info', DNICampaignInfo)

class DNIEnableFeatures extends HTMLElement {
  constructor(is_admin, data) {
    super();
    this._is_admin = is_admin
    this.data = data;
  }
  connectedCallback() {
    this.innerHTML = 
    `<style>
    .col-md-8 i {
      font-style: italic;
      font-weight: normal;
    }
    </style>
    <div class="step-number-header step-number-hidden">
      <div class="campaign-step-num"><span>2</span></div>
      <h4>Enabled Features</h4>
    </div>
    
    <div class="step-container hidden">
      <div class="camp-line">
        <div class="camp-vertical-arrow hidden">
          <div class="camp-arrow-down"></div>
        </div>
      </div>
      <div class="step-main">
        <div class="panel panel-default campaign-panel">
          <div class="errors" data-cy="errors-2"></div>
          <div class="row call-options">
            <div class="col-sm-6 col-xs-12">
              <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-6" align="left">CallShield</label>
                <div class="col-md-6"  align="left">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="call-shield-switch">
                    <span data-cy="call-shield-switch"></span>
                  </label>
                </div>
              </div>
              ${this._is_admin ?
              `<div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-6" align="left">LeadScore</label>
                <div class="col-md-6"  align="left">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="call-processing-map-switch">
                    <span data-cy="call-processing-map-switch"></span>
                  </label>
                </div>
              </div>` : ''}
              <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-6" align="left">Call Recording 
                <span>
                <span class="fas fa-question-circle" data-toggle="tooltip" data-placement="right" data-html="true" 
                title="<p style='text-align:left'>Call Recording includes a Recording Disclaimer to announce this call is being recorded</p>"</span>
                </span>
                </label>
                <div class="col-md-6"  align="left">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="call-rec-switch">
                    <span data-cy="call-rec-switch"></span>
                  </label>
                </div>
              </div>

              ${this._is_admin ? `
              <div class="dni-speech-transcription-enabled hidden" id="redaction-panel">
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                  <label class="col-md-6" align="left">Speech Transcription
                  </label>
                  <div class="col-md-6"  align="left">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" id="speech-transcription-enabled-switch">
                      <span data-cy="speech-transcription-enabled-switch"></span>
                    </label>
                  </div>
                </div> 
                
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                  <label class="col-md-6" align="left">Redaction
                  </label>
                  <div class="col-md-6"  align="left">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" 
                      disabled=true
                      id="redaction-enabled-switch">
                      <span data-cy="redaction-enabled-switch"></span>
                    </label>
                  </div>
                </div>
              </div>
              ` : ``}

            </div>

            <div class="col-sm-6 col-xs-12">
              <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
              <div>
              <label class="col-md-8 no-gutters" align="left">Texting Enabled<br>            
              </label>
 
              
              </div>
                <div class="col-md-4"  align="left">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="texting-enabled-switch">
                    <span data-cy="texting-enabled-switch"></span>
                  </label>
                </div>
              </div>
              <div class="row col-sm-12 dni-text-enabled hidden" id="texting-enabled-panel">
                <div class="col-sm-2 no-gutters">
                  <label>Team</label>
                </div>
                <div class="col-sm-10">
                  <select name="teams" is="teams-select" class="select-teams form-control" id="texting-team-select"></select>
                </div>
              </div> 
              <div class="hidden" id="disclaimer-panel" data-cy="call-disclaimer">
                <div>
                  <label>Recording Announcement</label>&nbsp<span>(Please select language):</span>
                </div>
                <div>
                  <input type="radio" name="disclaimer-lang" value="1" data-cy="lang-english" checked>
                  <label>English</label>
                </div>
                <div>
                  <input type="radio" name="disclaimer-lang" value="2" data-cy="lang-spanish">
                  <label>Spanish</label>
                </div>
                <div>
                  <input type="radio" name="disclaimer-lang" value="3" data-cy="lang-french">
                  <label>French</label>
                </div>
                ${this._is_admin ? '<div><input type="radio" name="disclaimer-lang" value="0" data-cy="lang-none"> <label>None</label></div>' : ''}
              </div>
            </div>

          </div>
        </div>
        <div class="campaign-buttons">                                                                        
          <button class="btn btn-primary pull-right campaign-row-button" id="dni-step-2-next" data-cy="dni-step-2-next">Next</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
        </div>
      </div>
    </div>`;

    this.querySelector('#call-rec-switch').onchange = (e) => {
      if(e.target.checked) {
        this.querySelector('#disclaimer-panel').classList.remove('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.remove('hidden');
        }
      } else {
        this.querySelector('#disclaimer-panel').classList.add('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.add('hidden');
        }
      }
    }

    this.querySelector('#texting-enabled-switch').onchange = (e) => {
      if(e.target.checked) {
        this.querySelector('#texting-enabled-panel').classList.remove('hidden');
      } else {
        this.querySelector('#texting-enabled-panel').classList.add('hidden');
      }
    }

    if(this._is_admin) {
      this.querySelector('#speech-transcription-enabled-switch').addEventListener('click', function(e) {
        if(e.target.checked) {
          this.querySelector('#redaction-enabled-switch').removeAttribute('disabled');
        } else {
          this.querySelector('#redaction-enabled-switch').setAttribute('disabled', true);
        }
      }.bind(this));
    }

    this.querySelector('#dni-step-2-next').addEventListener('click', function(e) {
      e.preventDefault();
       if(this.validateStep()) {
        this.querySelector('.campaign-buttons').classList.add('hidden');
        this.querySelector('.camp-vertical-arrow').classList.remove('hidden');
        document.querySelector('dni-advanced-settings').revealStep();
       }
    }.bind(this))

    
    
  }
  revealStep() {
    this.querySelector('.step-number-header').classList.remove('step-number-hidden');
    this.querySelector('.step-container').classList.remove('hidden');
    this.querySelector('.campaign-step-num').classList.add('campaign-step-active');
    this.querySelector('.step-number-header').scrollIntoView({behavior: "smooth"});
  }

  compileData() {
    this.data.call_shield = this.querySelector('#call-shield-switch').checked ? 1 : 0;
    if(this._is_admin) {
      this.data.call_processing_map = this.querySelector('#call-processing-map-switch').checked ? 1 : 0;
    } else {
      this.data.call_processing_map = 0;
    }

    this.data.call_recording = this.querySelector('#call-rec-switch').checked ? 1 : 0;
    this.data.call_disclaimer = this.querySelector('input[name="disclaimer-lang"]:checked').value;

    this.data.text_enabled = this.querySelector('#texting-enabled-switch').checked ? 1 : 0;
    this.data.texting_team_id = this.querySelector('#texting-team-select').value

    this.data.speech_transcription = this._is_admin ? (this.data.call_recording && this.querySelector('#speech-transcription-enabled-switch').checked ? 1 : 0) : 0;
    if (this.data.speech_transcription) {
      this.data.redaction = this.querySelector('#redaction-enabled-switch').checked ? 1 : 0;
    } else {
      // if transcription is off, force redaction to be off too.
      this.data.redaction = 0;
    }
  }

  validateStep() {
    let is_valid = true;
    this.querySelector('.errors').innerHTML = "";
    this.querySelector('.error') ? this.querySelector('.error').classList.remove('error') : null;
    if(this.querySelector('#texting-enabled-switch').checked && !this.querySelector('#texting-team-select').value) {
      this.querySelector('.errors').innerHTML += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> You must select a team if texting is enabled.
                                                  </div>`;
      this.querySelector('#texting-team-select').classList.add('error');
      is_valid = false
    }

    // add above logic for transcription/redaction
    // if transcription is off, so is redaction.
    
    if(this._is_admin) {
      if(this.querySelector('#call-processing-map-switch').checked && !this.querySelector('#call-rec-switch').checked) {
        this.querySelector('.errors').innerHTML += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                      <strong>Warning!</strong> Call Recording must be turned on when turning on LeadScore.
                                                    </div>`;
        is_valid = false
      }
    }
    return is_valid;
  }
}

customElements.define('dni-enable-features', DNIEnableFeatures)

export class DNIAdvancedSettings extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }
  connectedCallback() {
    this.innerHTML = 
    `<style>
    </style>
    <div class="step-number-header step-number-hidden">
      <div class="campaign-step-num"><span>3</span></div>
      <h4>Advanced Settings</h4>
    </div>
    
    <div class="step-container hidden">
      <div class="camp-line">
        <div class="camp-vertical-arrow hidden">
          <div class="camp-arrow-down"></div>
        </div>
      </div>
      <div class="step-main">
        <div class="panel panel-default campaign-panel">
          <div class="errors" data-cy="errors-3"></div>
          <div id="step-3-radio">
            <input type="radio" name="step-3-toggle" id="ring-to-radio" data-cy="ring-to-radio" checked>
            <label>Ring to Number
            <span class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" data-html="true" 
            title="<p style='text-align:left'>Forward call to the phone number or SIP address of your choice</p>"</span>
            </span>
            </label>
            <input type="radio" name="step-3-toggle" id="call-treat-radio" data-cy="call-treat-radio">
            <label>Call Treatment</label>
          </div>
          <div id="ring-to-panel" data-cy="ring-to-panel">
            <input type="text" is="ring-to-endpoint" class="form-control ring_to_endpoint" id="new-dni-rtn" data-cy="new-dni-rtn" data-key="ring_to_endpoint" placeholder="(123) 444-5566 or SIP Target">
            <div id="step-3-audio" class="col-sm-12 no-gutters">
              <div><label>Consumer Greeting</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=2 class="form-control" id="consumer-greeting-select" data-cy="consumer-greeting"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="2">Manage</button>
              </div>
              <div><label>Sales Rep Whisper</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=4 class="form-control" id="sales-rep-select" data-cy="sales-rep-whisper"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="4">Manage</button>
              </div>
            </div>

            <div class="form-group form-horizontal col-sm-12 no-gutters" align="right" role="form">
              <label class="col-md-4 no-gutters" align="left">Call Ends - Assign Representative Code</label>
              <div class="col-md-8"  align="left">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="representive-code-switch">
                  <span data-cy="representive-code-switch"></span>
                </label>
              </div>
            </div>

            <div class="form-group form-horizontal col-sm-12 no-gutters" align="right" role="form">
              <label class="col-md-4 no-gutters" align="left">Voicemail</label>
              <div class="col-md-2"  align="left">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="dni-voicemail-switch">
                  <span data-cy="dni-voicemail-switch"></span>
                </label>
              </div>
              <div id="dni_voicemail_rings_container" class="col-md-6 hidden" align="left">
                <label class="col-md-4">Number of Rings</label>
                <div class="col-md-4 no-gutters">
                  <select id="dni_voicemail_rings" class="form-control">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </div>
              </div>
            </div>
            <div id="dni_voicemail_audio" class="col-sm-12 no-gutters hidden">
              <div class="col-sm-12 no-gutters"><label>Voicemail Greeting</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=6 class="form-control" id="dni-voicemail-greeting-select" data-cy="dni-voicemail-greeting-select" default_option_text="Default"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="6">Manage</button>
              </div>
            </div>

            <div class="panel-body form-group-separated form-horizontal">
              <div>
                <label class="control-label" style="margin-top: 20px">Webhook</label>
              </div>
              <div class="campaign_webhooks_container" data-cy="campaign-webhooks">
                <webhook-form></webhook-form>
              </div>
            </div>
          </div>
          <div id="call-treat-panel" class="hidden" data-cy="call-treat-panel hidden">
            <label>Call Treatment</label>
            <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" value=""></select>
          </div>
        </div>
        <div class="campaign-buttons">                                                                        
          <button class="btn btn-primary pull-right campaign-row-button" id="dni-step-3-next" data-cy="dni-step-3-next">Next</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
        </div>
      </div>
    </div>`;

    this.querySelectorAll('#step-3-radio input').forEach(radio => {
      radio.addEventListener('click', function() {
        let ringToPanel = this.querySelector('#ring-to-panel');
        let callTreatPanel = this.querySelector('#call-treat-panel');
        if(this.querySelector('#ring-to-radio').checked){
          ringToPanel.classList.remove('hidden');
          callTreatPanel.classList.add('hidden');
          this.querySelector('.call_treatments_id').value = "";
        } else if(this.querySelector('#call-treat-radio').checked) {
          ringToPanel.classList.add('hidden');
          callTreatPanel.classList.remove('hidden');
        }
      }.bind(this))
    })

    this.querySelector('#dni-step-3-next').addEventListener('click', function(e) {
      e.preventDefault();
      if(this.validateStep()) {
        this.querySelector('.campaign-buttons').classList.add('hidden');
        this.querySelector('.camp-vertical-arrow').classList.remove('hidden');
        document.querySelector('dni-number-settings').revealStep();
      }
    }.bind(this))

    this.querySelector('#dni-voicemail-switch').addEventListener('click', function() {
      if(this.querySelector('#dni-voicemail-switch').checked == false) {
        this.querySelector('#dni_voicemail_rings_container').classList.add('hidden');
        this.querySelector('#dni_voicemail_audio').classList.add('hidden');
      } else {
        this.querySelector('#dni_voicemail_rings_container').classList.remove('hidden');
        this.querySelector('#dni_voicemail_audio').classList.remove('hidden');
      }
    }.bind(this))
  }
  revealStep() {
    this.querySelector('.step-number-header').classList.remove('step-number-hidden');
    this.querySelector('.step-container').classList.remove('hidden');
    this.querySelector('.campaign-step-num').classList.add('campaign-step-active');
    this.querySelector('.step-number-header').scrollIntoView({behavior: "smooth"});
  }

  validateStep() {
    this.querySelector('.errors').innerHTML = "";
    this.querySelector('.error') ? this.querySelector('.error').classList.remove('error') : null;
    if(this.querySelector('#ring-to-radio').checked && !this.querySelector('#new-dni-rtn').value) {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please provide a valid phone number.
                                                </div>`;
      this.querySelector('#new-dni-rtn').classList.add('error');
      return false
    } else if(this.querySelector('#call-treat-radio').checked && !this.querySelector('.call_treatments_id').value) {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a call treatment.
                                                </div>`;
      this.querySelector('.call_treatments_id').classList.add('error');
      return false
    }
    return true
  }

  compileData() {
    this.data.target = {};
    if(this.querySelector('#ring-to-radio').checked == true) {
      let ring_to = this.querySelector('#new-dni-rtn').value.split("@");
      if(ring_to.length == 1) {
         this.data.target.ring_to_number = ring_to[0].replace(/\D/g,'');
         this.data.target.ring_to_domain = null;
      } else {
         this.data.target.ring_to_number = ring_to[0].replace(/\D/g,'');
         this.data.target.ring_to_domain = ring_to[1]
      }

      this.data.target.actions = [];

      let consumer_greeting = this.querySelector('#consumer-greeting-select').value;
      if(consumer_greeting != "null") {
        let action = {
          action_timing: 1,
          action_type: "AUDIO",
          action_parameters: [{
            parameter_name: "audio_id",
            parameter_value: consumer_greeting
          }, 
          {
            parameter_name: "channel",
            parameter_value: DNIAdvancedSettings.CHANNEL_AUDIO_CONSUMER
          }]
        }
        this.data.target.actions.push(action);
      }
      
      let sales_rep_whisper = this.querySelector('#sales-rep-select').value;
      if(sales_rep_whisper != "null") {
        let action = {
          action_timing: 3,
          action_type: "AUDIO",
          action_parameters: [{
            parameter_name: "audio_id",
            parameter_value: sales_rep_whisper
          }, 
          {
            parameter_name: "channel",
            parameter_value: DNIAdvancedSettings.CHANNEL_AUDIO_TARGET
          }]
        }
        this.data.target.actions.push(action);
      }
      
      this.querySelectorAll("webhook-form").forEach((webhook_form) => {
        let webhook_value = webhook_form.getValue();
        if(webhook_value != null) {
          this.data.target.actions.push(webhook_value);  
        }
      });

      if(this.querySelector("#representive-code-switch").checked) {
        this.data.target.actions.push({
          action_timing: 6,
          action_type: "REP_CODE"
        })
      }

      this.data.voicemail_enabled = this.querySelector("#dni-voicemail-switch").checked ? 1 : 0;
      if(this.querySelector('#dni-voicemail-switch').checked) {
        this.data.voicemail_rollover_time = this.querySelector("#dni_voicemail_rings").value;
        this.data.voicemail_audio_id = this.querySelector("#dni-voicemail-greeting-select").value == "null" ? null : this.querySelector("#dni-voicemail-greeting-select").value;
      }
    } else if (this.querySelector('#call-treat-radio').checked == true) {
      this.data.target.target_id = this.querySelector('.call_treatments_id').value;
    }
  }
}

DNIAdvancedSettings.CHANNEL_AUDIO_CONSUMER = 0;
DNIAdvancedSettings.CHANNEL_AUDIO_TARGET = 1;

customElements.define('dni-advanced-settings', DNIAdvancedSettings)

class DNINumberSettings extends HTMLElement {
  constructor(data) {
    super();
    this.data = data    
  }
  connectedCallback() {
    this.innerHTML = 
    `<style>
      dni-number-settings .campaign-panel {
        height: 360px;
      }
    </style>
    <div class="step-number-header step-number-hidden">
      <div class="campaign-step-num"><span>4</span></div>
      <h4>Number Settings</h4>
    </div>
    
    <div class="step-container hidden">
      <div class="camp-line">
        <div class="camp-vertical-arrow hidden">
          <div class="camp-arrow-down"></div>
        </div>
      </div>
      <div class="step-main">
        <div class="panel panel-default campaign-panel">
          <div class="errors" data-cy="errors-4"></div>
          <section>
            <div class="row">
              <p>Find <b><u><span id="dni-step-four-count"></span> numbers</u></b> to assign to your pool</p>
              <p><i>The selected numbers will be active and connected in 15 minutes.</i></p>
              <div class="col-md-4 no-gutters form-group">
                <label for="exampleFormControlInput1">Toll Free or Local</label><br/>
                <input type="checkbox" id="campaign_wizard_toll_free" data-key="toll_free" class="wizard_toggle campaign_toll_free" data-on-text="Toll Free" data-off-color="default" data-off-text="Local">
              </div>
              <div class="col-md-8 form-group" id="local-tollfree-numbers">
                <local-numbers class="hidden" numbers-required="5"></local-numbers>
                <toll-free-numbers class="hidden"></toll-free-numbers>
              </div>
            </div>
          </section>
        </div>
        <div class="campaign-buttons">                                                                        
          <button class="btn btn-primary pull-right campaign-row-button" id="step-4-finish" data-cy="step-4-finish">Finish</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
        </div>
      </div>
    </div>`;

    $(this.querySelector("#campaign_wizard_toll_free")).bootstrapSwitch('state', true);

    $(this.querySelector("#campaign_wizard_toll_free")).on('switchChange.bootstrapSwitch', function(event, state) {
      if(!state) {
        this.querySelector('#local-tollfree-numbers').classList.remove('col-md-8');
        this.querySelector('#local-tollfree-numbers').classList.add('col-md-12', 'no-gutters');
      } else {
        this.querySelector('#local-tollfree-numbers').classList.remove('col-md-12', 'no-gutters');
        this.querySelector('#local-tollfree-numbers').classList.add('col-md-8');
      }
    }.bind(this));
  }

  get pool_size() {
    return this.numbers_required;
  }

  set pool_size(size) {
    this.numbers_required = size;
    this.querySelector("#dni-step-four-count").innerHTML = size;
    this.querySelector("local-numbers").setAttribute("numbers-required", size)
  }

  revealStep() {
    this.querySelector('.step-number-header').classList.remove('step-number-hidden');
    this.querySelector('.step-container').classList.remove('hidden');
    this.querySelector('.campaign-step-num').classList.add('campaign-step-active');
    this.querySelector('.step-number-header').scrollIntoView({behavior: "smooth"});
  }

  validateStep() {
    this.querySelector('.errors').innerHTML = "";
    if(document.querySelector('#texting-enabled-switch') != null && document.querySelector('#texting-enabled-switch').checked == true && this.querySelector('#campaign_wizard_toll_free').checked == true) {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Texting cannot be enabled on toll free numbers.
                                                </div>`;
      return false;
    }
    return true; // Will require validation to confirm you have enough numbers selected.
  }

  compileData() {
    if(this.querySelector(".campaign_toll_free").checked) {
      this.data.npanxx = [{"npanxx": this.querySelector("toll-free-numbers").value, "qtyRequired": this.numbers_required}]
    } else {
      this.data.npanxx = this.querySelector("local-numbers").value
    }
  }
}

customElements.define('dni-number-settings', DNINumberSettings)